<template>
  <div class="space-y-12">
    <section :aria-labelledby="`${panelId}-heading`">
      <h2
        :id="`${panelId}-heading`"
        class="text-2xl text-black dark:text-white"
      >
        {{ $t("pages.guide.about", { name: guide.first_name }) }}
      </h2>
      <div
        v-if="guide.bio"
        class="guide-bio mt-5 max-w-[72ch] text-base leading-7 text-black/80 dark:text-white/80"
        data-test="guide-bio"
        v-html="guide.bio"
      ></div>
      <GuideEmptyState
        v-else
        class="mt-5"
        icon="smile"
        :title="$t('pages.guide.aboutEmptyTitle')"
        :description="$t('pages.guide.aboutEmptyDescription')"
      />
    </section>

    <section
      v-if="guide.products?.length"
      :aria-labelledby="`${panelId}-tours-heading`"
    >
      <div class="flex flex-wrap items-center gap-3">
        <h2
          :id="`${panelId}-tours-heading`"
          class="text-2xl text-black dark:text-white"
        >
          {{ $t("pages.guide.guideTours", { name: guide.first_name }) }}
        </h2>
        <span
          class="rounded-full bg-gold/15 px-2.5 py-1 text-xs font-bold text-black dark:text-white"
          >{{ guide.products.length }}</span
        >
      </div>
      <div class="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-2">
        <TourCard
          v-for="tour in guide.products"
          :key="tour.id"
          :tour="tour"
          :is-city-specific="true"
          :is-booked="true"
        />
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import type { Guide } from "@/types";

defineProps<{
  guide: Guide;
  panelId: string;
}>();
</script>

<style scoped>
.guide-bio :deep(p + p),
.guide-bio :deep(ul),
.guide-bio :deep(ol) {
  margin-top: 1rem;
}

.guide-bio :deep(ul),
.guide-bio :deep(ol) {
  padding-left: 1.5rem;
}

.guide-bio :deep(ul) {
  list-style: disc;
}

.guide-bio :deep(ol) {
  list-style: decimal;
}

.guide-bio :deep(a) {
  color: var(--color-black);
  font-weight: 600;
  text-decoration: underline;
  text-decoration-color: var(--color-gold);
  text-decoration-thickness: 2px;
  text-underline-offset: 3px;
}

:global(.dark) .guide-bio :deep(a) {
  color: var(--color-white);
}
</style>
